import React from "react";
import { Box, IconButton, Popover } from "@mui/material";
import AddReactionIcon from "@mui/icons-material/AddReaction";

// Common emoji reactions
const QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🎉", "🔥", "👀"];

interface ReactionPickerProps {
  onSelect: (emoji: string) => void;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  open: boolean;
}

export const ReactionPicker: React.FC<ReactionPickerProps> = ({
  onSelect,
  anchorEl,
  onClose,
  open,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            boxShadow: 3,
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          p: 1,
          bgcolor: "background.paper",
        }}
      >
        {QUICK_REACTIONS.map((emoji) => (
          <IconButton
            key={emoji}
            size="small"
            onClick={() => {
              onSelect(emoji);
              onClose();
            }}
            sx={{
              fontSize: "1.25rem",
              transition: "transform 0.15s",
              "&:hover": {
                transform: "scale(1.3)",
                bgcolor: "action.hover",
              },
            }}
          >
            {emoji}
          </IconButton>
        ))}
      </Box>
    </Popover>
  );
};

interface ReactionButtonProps {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const ReactionButton: React.FC<ReactionButtonProps> = ({ onClick }) => {
  return (
    <IconButton
      size="small"
      onClick={onClick}
      sx={{
        opacity: 0,
        transition: "opacity 0.2s",
        ".message-item:hover &": {
          opacity: 1,
        },
      }}
    >
      <AddReactionIcon fontSize="small" />
    </IconButton>
  );
};

export default ReactionPicker;
